/**
 * Centralized constants for the Incident Management system.
 * Replaces hardcoded magic strings scattered across components.
 */

// ============================================================================
// STATUS CONSTANTS
// ============================================================================

export enum IncidentStatusEnum {
    Open = "Open",
    Pending = "Pending",
    Resolved = "Resolved",
    Rejected = "Rejected",
    InReview = "In Review",
}

/**
 * Maps incident statuses to their display colors.
 * Used in Ag-Grid column styling and status badges.
 */
export const INCIDENT_STATUS_COLORS: Record<string, string> = {
    [IncidentStatusEnum.Resolved]: "#4CAF50",
    [IncidentStatusEnum.Pending]: "#FFC107",
    [IncidentStatusEnum.Rejected]: "#F44336",
    [IncidentStatusEnum.InReview]: "#FF9800",
    [IncidentStatusEnum.Open]: "#2196F3",
};

// ============================================================================
// DEPARTMENT CONSTANTS
// ============================================================================

export enum IncidentDepartmentEnum {
    FireSafety = "Fire Safety",
    WashroomManagement = "Washroom Management",
    EquipmentManagement = "Equipment Management",
    ExternalEmergencyPreparedness = "External Emergency Preparedness",
}

// ============================================================================
// API ENDPOINT PATHS (per department)
// ============================================================================

/**
 * Maps each department to the API endpoint path used to fetch its incidents.
 * The base URL is provided by axiosInstance; these are relative paths.
 */
export const DEPARTMENT_INCIDENT_ENDPOINTS: Record<string, string> = {
    [IncidentDepartmentEnum.FireSafety]: "/api/incidents/department",
    [IncidentDepartmentEnum.WashroomManagement]: "/api/washroomincidents/department",
    [IncidentDepartmentEnum.EquipmentManagement]: "/api/equipmentincidents/department",
    [IncidentDepartmentEnum.ExternalEmergencyPreparedness]: "/api/incidents/department",
};
